function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#393762",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.4
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.375 21.25c0 1.036-.839 1.875-1.875 1.875h-25c-1.035 0-1.875-.839-1.875-1.875V2.5c0-1.035.84-1.875 1.875-1.875h25c1.036 0 1.875.84 1.875 1.875v18.75h0zM6.25 26.875L23.75 26.875M19.375 26.875L10.625 26.875 11.875 23.125 18.125 23.125z",
  transform: "translate(1 1)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.125 18.125L26.875 18.125 26.875 3.125 3.125 3.125zM15.625 20.625c0 .345-.28.625-.625.625s-.625-.28-.625-.625S14.655 20 15 20s.625.28.625.625h0z",
  transform: "translate(1 1)"
}));

var SvgSite = function SvgSite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 29,
    viewBox: "0 0 32 29",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/site.90a9d471.svg";
export { ForwardRef as ReactComponent };